/* eslint-disable camelcase */
import { defineMessages } from 'react-intl';

const specialOfferCodeDeliveryMessages = defineMessages({
  offer_2022_setapp_1pass: {
    id: 'specialOffer.productCodeDelivery.1password',
    defaultMessage: 'Your 1Password code is on the way to your email.',
  },
  offer_2022_setapp_mc: {
    id: 'specialOffer.productCodeDelivery.masterclass',
    defaultMessage: 'Your MasterClass code is on the way to your email.',
  },
  offer_2022_setapp_1pass_mc: {
    id: 'specialOffer.productCodeDelivery.1password+masterclass',
    defaultMessage: 'Your 1Password and MasterClass codes are on the way to your email.',
  },
});

export default specialOfferCodeDeliveryMessages;
